/// <amd-module name="Repos/Views/PullRequest/Util/Vote" />
import { IdentityRefWithVote } from "Repos/Common/Contracts/Git";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { IStatusProps, Statuses } from "VSSUI/Status";
import { IRequiredReviewersPolicyEvaluation, IReviewer, ReviewerVote } from "../Contracts/PullRequest";

export function getVoteStatusProps(vote: ReviewerVote): IStatusProps {
    switch (vote) {
        case ReviewerVote.Approved:
        case ReviewerVote.ApprovedWithSuggestion:
            return { ...Statuses.Success, ariaLabel: Resources.VoteApproved };
        case ReviewerVote.WaitingForAuthor:
            return { ...Statuses.Waiting, ariaLabel: Resources.VoteWaitingForAuthor, color: "warning" };
        case ReviewerVote.Rejected:
            return { ...Statuses.Failed, ariaLabel: Resources.VoteRejected };
        case ReviewerVote.NoVote:
            return { ...Statuses.Queued, ariaLabel: Resources.VoteNoVote };
    }
}

export function getVoteText(vote: ReviewerVote): string {
    switch (vote) {
        case ReviewerVote.Approved:
            return Resources.VoteApproved;
        case ReviewerVote.ApprovedWithSuggestion:
            return Resources.VoteApprovedWithSuggestions;
        case ReviewerVote.WaitingForAuthor:
            return Resources.VoteWaitingForAuthor;
        case ReviewerVote.Rejected:
            return Resources.VoteRejected;
        case ReviewerVote.NoVote:
            return Resources.VoteNoVote;
    }
}

export function hasApproved(vote: ReviewerVote) {
    return vote === ReviewerVote.Approved || vote === ReviewerVote.ApprovedWithSuggestion;
}

/**
 * Gets the number of approval votes for this reviewer.
 * Typically will be 0 or 1.
 * If many approved, it may become negative.
 * If the group has a policy with minimumApproverCount and/or creatorVoteCounts, that will be considered.
 */
export function getValidApprovalVotes(
    voters: IdentityRefWithVote[],
    strictestPolicy: IRequiredReviewersPolicyEvaluation | undefined,
    creatorId: string
): number {
    const creatorVoteCounts = !strictestPolicy || strictestPolicy.creatorVoteCounts;
    const approvers = voters && voters.filter(voter => hasApproved(voter.vote) && (creatorVoteCounts || voter.id !== creatorId));
    return (approvers || []).length;
}

/**
 * Gets the number of pending approvals for this reviewer to be considered approved.
 */
export function getPendingVotes(reviewer: IReviewer, creatorId: string) {
    const voters = reviewer.baseReviewer.isContainer ? reviewer.votedForBy : [reviewer.baseReviewer];
    const approvalVotes = getValidApprovalVotes(voters, reviewer.strictestPolicy, creatorId);
    const minimumApproverCount = (reviewer.strictestPolicy && reviewer.strictestPolicy.minimumApproverCount) || 1;
    return minimumApproverCount - approvalVotes;
}
